import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import SelectListComponent from "../SelectListComponent";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const CreateContentDescriptorType = () => {
  const [message, setMessage] = useState("");
	const token = globalConfig.hardcoded_header;
  const [contentDescriptorTypeCodes, setContentDescriptorTypeCodes] = useState(
    []
  );

  const [state, setState] = useState({
    contentDescriptorTypeId: 0,
    contentDescriptorTypeValue: 0,
    contentDescriptorTypeDescr: "",
    contentDescriptorTypeCdata: "",
    contentDescriptorTypeBdata: "",
    securityContextId: 0,
    createUser: 0,
    createDate: new Date().toISOString(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });

  useEffect(() => {
    handleOnLoad();
  }, []);
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  //   function handleDropDown(event) {
  //     console.log(event);
  //     var target = event.target;
  //     console.log(target.id + ":" + target.value);
  //     this.setState({
  //       [target.id]: parseInt(target.value),
  //     });

  //     console.log(this.state);
  //   }

  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-descriptor-types`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-descriptor-types/contentDescriptorTypeId`;
    console.log("Hello world");
    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentDescriptorTypeId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentDescriptorTypeId
          );
          // && response2.data.contentTemplateTypeId === this.state.contentTemplateTypeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      //     console.log(response.data)
      //          .catch(err => {
      //             console.log(err);
      //           });
      console.log("message info - " + message);
      setState({ ...state, contentTemplateTypeDescr: " " });
    });

    // console.log("SetState Message info-" + this.contentObjectName);
    // console.log("SetState Message info-" + this.contentCategoryName);
    // console.log("SetState Message info-" + this.contentCategoryDescr);
  }
  function handleRest(event) {
    setState({
      contentDescriptorTypeDescr: "",
    });
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_DESCRIPTOR_TYPE`,
         apiHeader(token)
      )
      .then((res) => {
        const contentDescriptorTypeCodes = res.data;
        console.log("results", contentDescriptorTypeCodes);
        setContentDescriptorTypeCodes(contentDescriptorTypeCodes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });
  };
  return (
    <form>
 		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Descriptor Type</h4>			
			<Link to="/breeze/list-content-descriptor-types">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>
     
      
      <div className="container-fluid">
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Descriptor Type Value Code"
          >
            Content Descriptor Type Value Code
          </label>
          <select
            id="contentDescriptorTypeValue"
            onChange={handleChange}
            className="form-control input-xlarge col-sm-8"
            value={state.contentDescriptorTypeValue}
          >
            <option value={0}>Select Descriptor Type Value Code </option>
            {contentDescriptorTypeCodes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
          {/* <SelectListComponent entityName ={"system-code-values"} valueFilterColumnName = {"systemCodeId"} valueFilter = {"234"} displayColumnName ={"systemCodeValueValue"} keyColumnName ={"systemCodeValueId"}
					IdName={"contentDescriptorTypeValue"}
					TypeId={state.contentDescriptorTypeValue}
					handle={handleDropDown}
					/>	 */}
        </div>
        {/* <div className="form-group row">
				<label className="ContentTitle col-sm-2" value="Content Descriptor Type Value Code">My select object</label>
				<SelectListComponent />	
			</div> */}
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Descriptor Type Description"
          >
            Content Descriptor Type Description
          </label>
          <textarea
            id="contentDescriptorTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentDescriptorTypeDescr}
            onChange={handleChange}
          />
        </div>
        {/* <div className="form-group row">
				<label className="ContentTitle col-sm-2" value="Content Descriptor Type CData">Content Descriptor Type CData</label>
				<input id="contentDescriptorTypeCdata" className="form-control input-xlarge col-sm-8" 
					value="#{ombContentDescriptorTypeForm.createContentDescriptorType.contentDescriptorTypeCdata}"/>
		</div> */}

        <hr />
        <div columns="3">
          <button
            className="btn btn-primary"
            value="Clear"
            onClick={handleRest}
          >
            Clear
          </button>
          &nbsp;
          <button
            className="btn btn-success"
            value="Create"
            onClick={handleSubmit}
          >
            Create
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateContentDescriptorType;
